import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';

const val = (v) => {
  if (v === null || v === undefined) return '-';
  const s = String(v).trim();
  return s ? s : '-';
};

export default function InjectQuickViewModal({ open, onOpenChange, inject, onOpenNotes, onEdit }) {
  const meta = inject?.metadata || {};

  const injectNo = val(inject?.inject_number || meta['Inject ID'] || meta['Inject Number']);
  const reference = val(meta['Objective ID'] || meta['ObjectiveID'] || '-');

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-secondary flex items-center justify-between gap-3">
            <span>INJECT: {injectNo}</span>
            <span className="text-xs text-muted-foreground">REFERENCE: {reference}</span>
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          {/* Top table */}
          <div className="rounded-lg border overflow-hidden">
            <div className="grid grid-cols-5 gap-0 bg-muted text-xs font-medium tracking-wider">
              <div className="px-4 py-2">INJECT TIME</div>
              <div className="px-4 py-2">METHOD</div>
              <div className="px-4 py-2">DEPENDANCY</div>
              <div className="px-4 py-2">RECIPIENT</div>
              <div className="px-4 py-2">SPEC. FUNC.</div>
            </div>
            <div className="grid grid-cols-5 gap-0 text-sm">
              <div className="px-4 py-3">{val(meta['Time of Inject (UTC)'] || meta['Inject Time'] || meta['INJECT TIME'] || inject?.delivery_time)}</div>
              <div className="px-4 py-3">{val(meta['Method'] || meta['METHOD'])}</div>
              <div className="px-4 py-3">{val(meta['Dependancy'] || meta['Dependency'] || meta['DEPENDANCY'])}</div>
              <div className="px-4 py-3">{val(meta['Recipient'] || meta['RECIPIENT'])}</div>
              <div className="px-4 py-3">{val(meta['Specific Function'] || meta['SPEC. FUNC.'] || meta['Spec. Func.'] || meta['SpecificFunction'])}</div>
            </div>
          </div>

          {/* Objective */}
          <div className="rounded-lg border overflow-hidden">
            <div className="bg-muted px-4 py-2 text-xs font-medium tracking-wider">OBJECTIVE</div>
            <div className="px-4 py-3 text-sm whitespace-pre-wrap">
              {val(meta['Objective'] || meta['OBJECTIVE'])}
            </div>
          </div>

          {/* Inject Information */}
          <div className="rounded-lg border overflow-hidden">
            <div className="bg-muted px-4 py-2 text-xs font-medium tracking-wider flex items-center justify-between">
              <span>INJECT INFORMATION</span>
              <span className="text-[10px] text-muted-foreground">
                INJECTED BY: {val(meta['Injected By'] || meta['INJECTED BY'] || inject?.triggered_by_name || inject?.created_by_name || inject?.created_by)} | TIME INJECTED: {val(meta['Time Injected'] || meta['TIME INJECTED'] || inject?.triggered_at)}
              </span>
            </div>
            <div className="px-4 py-3 text-sm whitespace-pre-wrap">
              {val(meta['Inject Information'] || meta['INJECT INFORMATION'] || inject?.content)}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="rounded-lg border overflow-hidden">
              <div className="bg-muted px-4 py-2 text-xs font-medium tracking-wider">SUPPLEMENTAL INFORMATION</div>
              <div className="px-4 py-3 text-sm whitespace-pre-wrap">{val(meta['Supplemental Information'] || meta['SUPPLEMENTAL INFORMATION'])}</div>
            </div>

            <div className="rounded-lg border overflow-hidden">
              <div className="bg-muted px-4 py-2 text-xs font-medium tracking-wider">KEY OUTCOMES</div>
              <div className="px-4 py-3 text-sm whitespace-pre-wrap">{val(meta['Key Outcomes'] || meta['KEY OUTCOMES'])}</div>
            </div>
          </div>

          <div className="flex justify-end gap-2">
            {onEdit && (
              <Button variant="outline" onClick={() => { onOpenChange(false); onEdit(inject); }} data-testid="inject-view-edit-btn">
                Edit
              </Button>
            )}
            <Button variant="outline" onClick={onOpenNotes} data-testid="inject-view-notes-btn">
              Notes
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
